import { useCallback } from "react";
import { usePreview } from "src/components/Modals/PreviewContext";
import { useAppNavigation } from "./Navigation/useAppNavigation";

export const useMoreLink = (moreLink: string | undefined) => {
  const { active: previewActive, goToPage: goToPagePreview } = usePreview();
  const { navigate } = useAppNavigation();

  const goToMoreLink = useCallback(() => {
    if (previewActive && moreLink) {
      goToPagePreview(moreLink);
    } else if (moreLink?.startsWith(`${process.env.REACT_APP_DEEPLINK_SCHEME}://`)) {
      navigate(moreLink?.replace(`${process.env.REACT_APP_DEEPLINK_SCHEME}://`, "/"));
    } else if (moreLink?.startsWith("http")) {
      window.open(moreLink, "_self");
    } else if (!!moreLink) {
      navigate(`/page/${moreLink}`);
    }
  }, [goToPagePreview, moreLink, navigate, previewActive]);

  return { handleMoreLink: goToMoreLink };
};
